import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function LockIcon({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.20079 7.96149H4.7578C3.73218 7.96149 2.8999 8.79563 2.8999 9.82449V22.1375C2.8999 23.1656 3.73247 24.0005 4.7578 24.0005H19.242C20.268 24.0005 21.0999 23.1659 21.0999 22.1375V9.82449C21.0999 8.79535 20.2683 7.96149 19.242 7.96149H16.7994V4.81249C16.7994 2.1545 14.6506 0.000488281 11.9996 0.000488281C9.34941 0.000488281 7.20079 2.15467 7.20079 4.81249V7.96149ZM8.19805 7.96149H15.8022V4.81249C15.8022 2.70686 14.0999 1.00049 11.9996 1.00049C9.90015 1.00049 8.19805 2.70699 8.19805 4.81249V7.96149ZM16.3008 8.96149H19.242C19.7176 8.96149 20.1026 9.34763 20.1026 9.82449V22.1375C20.1026 22.6137 19.7172 23.0005 19.242 23.0005H4.7578C4.28324 23.0005 3.89716 22.6133 3.89716 22.1375V9.82449C3.89716 9.34803 4.28284 8.96149 4.7578 8.96149H7.69942H16.3008Z'
      />
    </svg>
  );
}
